/**
 * feature flags names in Switchboard
 * i.e TEST_FLAG = 'switchboard-featureFlag-name'
 */
export enum FeatureFlags {
  HEADER_CART = 'reseller-storefront-header-cart',
  AJAX_ADD_TO_CART = 'reseller-storefront-ajax-add-to-cart'
}
